import useScreenSize from "@/modules/common/hooks/device-detection.hook";
import { getContrastColor } from "@/modules/common/utils";
import { muiTheme } from "@/styles/theme";
import { Box, Typography } from "@mui/material";

interface UserTagProps {
  name?: string;
  image?: string;
  color?: string;
  showfullName?: boolean;
  inLeadsTable?: boolean;
}

const UserTag: React.FC<UserTagProps> = ({
  name,
  image,
  color,
  showfullName = true,
  inLeadsTable = false,
}) => {
  const getUserName = (fullName: string): string => {
    const nameParts = fullName.split(" ");
    const prefixRegex = /^(el|al|abo|abou|abu)/i;
    const prefixIndex = nameParts.findIndex((part) =>
      prefixRegex.test(part.toLowerCase())
    );

    if (prefixIndex !== -1 && nameParts.length > prefixIndex + 1) {
      return nameParts.slice(0, prefixIndex + 3).join(" ");
    } else {
      return nameParts.slice(0, 2).join(" ");
    }
  };

  const getInitials = (name: string): string => {
    const username = getUserName(name);
    const initials = username
      .split(" ")
      .slice(0, 2)
      .map((word) => word.charAt(0))
      .join("");
    return initials.toUpperCase();
  };

  const { isMobile } = useScreenSize();

  if (!name) {
    return null;
  }

  return (
    <Box
      sx={{
        maxWidth: "100%",
        maxHeight: "30px",
        display: "flex",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          minWidth: "30px",
          height: "30px",
          borderRadius: "100%",
          fontFamily: "Medium",
          // fontSize: muiTheme.typography.fontSize.body_sm_med,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 1,
          backgroundColor: "#FFF",
          img: {
            maxWidth: "100%",
            maxHeight: "100%",
          },
        }}
      >
        <Box
          sx={{
            minWidth: "30px",
            height: "30px",
            borderRadius: "100%",
            border: `1px solid #ffffff`,
            fontFamily: "Medium",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1,
            backgroundColor: color
              ? color
              : muiTheme.colorSchemes.light.palette.success[300],
            color: getContrastColor(color || "#4CAF50"),
            img: {
              maxWidth: "100%",
              maxHeight: "100%",
            },
          }}
        >
          {!image ? getInitials(name) : <img src={image} />}
        </Box>
      </Box>
      {showfullName === true && (
        <Box
          sx={{
            padding: "4px 8px",
            backgroundColor: color
              ? color
              : muiTheme.colorSchemes.light.palette.success[300],
            marginLeft: "-5px",
            borderRadius: "0px 4px 4px 0px",
            display: "flex",
            alignItems: "center",
            justifyContent: "start",
            color: getContrastColor(color || "#4CAF50"),
            textTransform: "capitalize",
          }}
        >
          <Typography
            sx={{
              whiteSpace: "pre-wrap",
              wordBreak: "normal",
              wordSpacing: "normal",
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              maxWidth: "fit-content",
              lineHeight: "0.9",
              fontSize:
                inLeadsTable && isMobile
                  ? "var(--dynamic-font-size)"
                  : muiTheme.typography.body_sm_med.fontSize,
              textOverflow: "ellipsis",
              overflowWrap: "break-word",
            }}
          >
            {getUserName(name)}
          </Typography>{" "}
        </Box>
      )}
    </Box>
  );
};

export default UserTag;
